<td class="ingredientStamp-title">
	<div class="ingredientStamp-titleWithCheckbox">
		<form [formGroup]="formGroup">
			<form-input [formControlName]="ingredientType + sku" inputType="checkbox" (change)="handleSelection()">
				<label
					[innerHTML]="ingredient.description | sentencecase"
					i18n="@@product-selectedForTrolley"
					[for]="ingredientType + sku"
					label
				>
				</label>
			</form-input>
		</form>
	</div>
</td>
<td class="ingredientStamp-image">
	<product-tag
		*ngIf="product?.productTag"
		[tag]="product?.productTag"
		[price]="product?.price"
		[asStrap]="false"
		[targetedOfferCropped]="false"
		[showTargetedOfferText]="false"
		[fixedSize]="true"
	></product-tag>
	<product-fuel-tag *ngIf="product?.productTag" [tag]="product?.productTag"></product-fuel-tag>
	<figure
		cdxProductImage
		[images]="product?.images"
		[name]="product?.name"
		size="extra-small"
		labelledBy="product-{{ uniqueid }}-title"
	></figure>
</td>
<td class="ingredientStamp-productInfo">
	<p class="ingredientStamp-productName">{{ product?.name | sentencecase }}</p>
	<product-price-meta
		*ngIf="productIsAvailable"
		[uniqueId]="uniqueid"
		[size]="product?.size"
		[cupPrice]="cupPrice"
		[isKgItem]="isKgItem"
		[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
	>
	</product-price-meta>
	<ng-container *ngTemplateOutlet="productPrice"></ng-container>
</td>
<td class="ingredientStamp-productQuantity" [attr.colspan]="quantityColSpan">
	<product-quantity-selector
		*ngIf="productIsAvailable"
		[id]="product?.sku"
		[unit]="product?.unit"
		[averageWeightPerUnit]="product?.averageWeightPerUnit"
		[layout]="'list'"
		[quantityResponse]="product?.quantity"
		(incrementEmitter)="updateQuantityClick($event)"
		(decrementEmitter)="updateQuantityClick($event)"
		(updateEmitter)="updateQuantityClick($event)"
	></product-quantity-selector>
	<p class="ingredientStamp-linePricePhone visible-phone">{{ linePrice | currency }}</p>
	<cdx-alert
		*ngIf="!productIsAvailable"
		[inlineLink]="true"
		type="warning"
		[animate]="false"
		[withMargin]="false"
		title="Ingredient out of stock"
	>
	</cdx-alert>
</td>
<td class="ingredientStamp-linePrice" *ngIf="productIsAvailable">
	{{ linePrice | currency }}
</td>

<ng-template #warningUnavailable>
	<cdx-alert
		[inlineLink]="true"
		type="warning"
		[animate]="false"
		[withMargin]="false"
		title="Out of stock.&nbsp;"
		class="hidden-phone"
		attr.data-cy="outOfStock-{{ product.sku }}"
	>
	</cdx-alert>
</ng-template>

<ng-template #productPrice>
	<product-price
		*ngIf="productIsAvailable"
		[layout]="layout.list"
		[price]="product?.price"
		[uniqueId]="uniqueid"
		[unit]="product?.unit"
		[supportsEachAndKgPricing]="product?.supportsBothEachAndKgPricing"
		[selectedPurchasingUnit]="product?.selectedPurchasingUnit"
		[isProductTagClubPrice]="isProductTagClubPrice"
	></product-price>
</ng-template>
